import { Component } from '@angular/core';
import { LoadingService } from './service/loading.service';
import { PopupService } from './service/popup.service';
import { TranslateService } from '@ngx-translate/core';
import { BrandService } from './service/brand.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'app';
  constructor(public loadingService: LoadingService,
    public popupService: PopupService,
    private brandService: BrandService,
    private translate: TranslateService) {
    translate.setDefaultLang('en');
    var french = this.brandService.inFrench();
  }

  onActivate(event): void {
    window.scroll(0, 0);

    //window.scroll({
    //  top: 0,
    //  left: 0,
    //  behavior: 'smooth'
    //});
  }
}
